import React from "react";
import { Box, Button, Grid, Tooltip } from "@material-ui/core";
import { compose } from "redux";
import { Link, withRouter } from "react-router-dom";
import withTheme from "@material-ui/styles/withTheme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  userRole: state.auth.role,
  idExploitation: state.exploitation.selected,
});
class MenuHve4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabSelected: "HVE4_SURFACE",
    };
  }

  render() {
    const {
      typesRubriques,
      typeRubriqueSelected,
      rubriqueSelected,
      setSousRubriqueSelected,
      theme,
      saveResult,
    } = this.props;

    const {
      dateAudit,
      etatDossier,
      commentaireAuditeur,
      commentaireExploitant,
      decision,
      dateDecision,
      resultatAuditComputed,
    } = this.props.commentairesSyntheseResultats;
    // Les rubriques du menu peuvent ne pas contenir Irrigation et donc avoir des indexs différents de la liste d'origine.
    // On se base donc sur le code national de la rubrique sélectionnée au lieu de l'index.
    const rubriqueSelectedCodeNational = typesRubriques[typeRubriqueSelected].rubriques[rubriqueSelected].codeNational;
    const isSynthese = rubriqueSelectedCodeNational === "HVE4_SYNTHESE" ?? false;

    // On fait une copie de la liste des rubriques pour ne pas répercuter le changement de référence sur la variable
    // contenant le tableau d'origine.
    let tr = [...typesRubriques[0].rubriques];
    if (!this.props.idExploitation.irrigation) {
      tr = tr.filter((r) => r.codeNational !== "HVE4_IRRIGATION");
    }

    const rubriqueSelectedIndex = tr.findIndex((r) => r.codeNational === rubriqueSelectedCodeNational);

    return (
      <Grid container>
        <Grid item xs={7}>
          <Box className={"menu-rubriques"}>
            {tr.map((rubrique, rubriqueIndex) => (
              <Button
                key={"rubrique-" + rubriqueIndex}
                style={{
                  borderRadius: rubriqueIndex === 0 ? "10px 0 0" : "0",
                  padding: "0.8em",
                  fontWeight: "bold",
                  backgroundColor:
                    rubriqueSelectedIndex === rubriqueIndex
                      ? theme.palette.primary.main
                      : theme.palette.type === "light"
                      ? "#eee"
                      : theme.palette.background.default,
                  color: theme.palette.text.primary,
                }}
                onClick={() => setSousRubriqueSelected(0, rubrique.codeNational)}
              >
                {rubrique.libelle}
              </Button>
            ))}
          </Box>
        </Grid>
        <Grid item xs={5}>
          <Box className={"ml-2"}>
            <Tooltip title={"Enregistrer"} placement={"bottom"}>
              <Button
                variant="contained"
                color="primary"
                onClick={
                  isSynthese
                    ? () =>
                        saveResult({
                          dateAudit,
                          etatDossier,
                          commentaireAuditeur,
                          commentaireExploitant,
                          decision,
                          dateDecision,
                          resultatAudit: resultatAuditComputed,
                        })
                    : () => setSousRubriqueSelected(0, tr[rubriqueSelectedIndex + 1].codeNational)
                }
              >
                <FontAwesomeIcon icon="save" className="mr-05" />
                Enregistrer
              </Button>
            </Tooltip>
            <Button variant="contained" className="ml-1" onClick={() => this.props.history.goBack()}>
              <FontAwesomeIcon icon="times" className="mr-05" />
              Annuler
            </Button>
            <Button className="mr-2 ml-2" component={Link} to={`/demarches/HVE4/infos`}>
              <FontAwesomeIcon icon="pencil-alt" className="mr-05" />
              Modifier la démarche
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  }
}
export default compose(withRouter, withTheme, connect(mapStateToProps))(MenuHve4);
